module.exports = __webpack_public_path__ + "media/images/club-logo/3-015f284f2e5db384344596d0ef35eff3.png";